// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__TFhZg","icon":"styles_icon__WFW08","description":"styles_description__YId9s","link":"styles_link__3A+3s","text":"styles_text__ESpTk"};